import { z } from 'zod';
import { packCodeSchema } from './enums.js';

/**
 * Pack tel qu'exposé par l'API publique et le back-office. Les prix HT sont
 * stockés en `numeric` côté Postgres (donc sérialisés en string) mais
 * normalisés en number côté API/UI pour faciliter le calcul de la fourchette.
 */
export const packSchema = z.object({
  id: z.string().uuid(),
  code: packCodeSchema,
  name: z.string().min(1),
  description: z.string().min(1),
  priceMinHt: z.number().nonnegative(),
  priceMaxHt: z.number().nonnegative(),
  active: z.boolean(),
});
export type Pack = z.infer<typeof packSchema>;

/**
 * Payload PATCH /api/admin/packs/:code. Tous les champs sont optionnels :
 * l'admin peut mettre à jour uniquement le prix, ou uniquement le statut
 * actif. `.strict()` rejette toute clé inconnue pour éviter de leaker
 * des colonnes non autorisées (id, code, createdAt).
 */
export const updatePackSchema = z
  .object({
    name: z.string().trim().min(1).max(120).optional(),
    description: z.string().trim().min(1).max(500).optional(),
    priceMinHt: z.number().nonnegative().max(1_000_000).optional(),
    priceMaxHt: z.number().nonnegative().max(1_000_000).optional(),
    active: z.boolean().optional(),
  })
  .strict()
  .refine(
    (data) =>
      data.priceMinHt === undefined ||
      data.priceMaxHt === undefined ||
      data.priceMinHt <= data.priceMaxHt,
    {
      message: 'priceMinHt doit être inférieur ou égal à priceMaxHt',
      path: ['priceMinHt'],
    },
  );
export type UpdatePackInput = z.infer<typeof updatePackSchema>;
